import React from 'react';
import './style.scss';
import SVGLandingNifty from '../../../assets/images/landing/nifty';
import SVGLogo from '../../../assets/images/logo';
import SVGLandingHands from '../../../assets/images/landing/hands';
import clsx from 'clsx';

interface Props {
  color?: string;
  minified?: boolean;
  className?: string;
}

const Copyright = ({ color = '#FF009C', minified, className }: Props) => (
  <div className={clsx('copyright', minified && 'minified', className)}>
    <div className='copyright-logo'>
      <SVGLandingNifty className='copyright-logo-left' color={color} />
      <SVGLogo color={color} className='copyright-logo-center' />
      <SVGLandingHands className='copyright-logo-right' color={color} />
    </div>
    <span className='copyright-wording' style={{ color }}>
      © All rights reserved 2022
    </span>
  </div>
);

export default Copyright;
